import { createContext } from 'react'

export const NestedListContext = createContext()
